<template>
  <div class="row">
    <div class="col-md-12">
      <Row type="flex" justify="space-between" :gutter="15">
        <i-col span="6">
          <CountPanel
            :loading="loading"
            url="stat/builds"
            color-class="stat-success"
            sub-title="账户总余额"
            icon-type="logo-usd"
            @onCompleteCallback="completeCallback"
          />
        </i-col>
        <i-col span="6">
          <CountPanel
            :loading="loading"
            url="stat/builds"
            color-class="stat-blue"
            sub-title="车库总收入"
            icon-type="md-cube"
            @onCompleteCallback="completeCallback"
          />
        </i-col>
        <i-col span="6">
          <CountPanel
            :loading="loading"
            url="stat/builds"
            color-class="stat-warning"
            sub-title="冻结金额"
            tooltip="正在提现中的金额统计"
            icon-type="logo-bitcoin"
            @onCompleteCallback="completeCallback"
          />
        </i-col>
        <i-col span="6">
          <CountPanel
            :loading="loading"
            url="stat/builds"
            color-class="stat-danger"
            sub-title="实际到账金额统计"
            icon-type="ios-cash-outline"
            tooltip="每次提现合伙人实际到账金额累加"
            @onCompleteCallback="completeCallback"
          />
        </i-col>
      </Row>
    </div>
    <div class="col-md-12">
      <Row type="flex" justify="space-between" :gutter="15">
        <i-col span="18">
          <CardPanel icon="fa-list-alt">
            <span slot="header">
              车库营收额
            </span>
            <div slot="content">
              test
            </div>
          </CardPanel>
        </i-col>
        <i-col span="6">
          <CardPanel icon="fa-list-alt">
            <span slot="header">
              车库营收额
            </span>
            <div slot="content">
              <ChartPanel :options="parkingOptions" />
            </div>
          </CardPanel>
        </i-col>
      </Row>
    </div>
  </div>
</template>

<script>
import ChartPanel from '@/components/chart-panel'
import CardPanel from '@/components/card-panel'
import CountPanel from '@/components/count-panel'
import { buildChartOptions } from '@/utils/echart'
export default {
  name: 'Account',
  components: { CountPanel, CardPanel, ChartPanel },
  data() {
    return {
      loading: false,
      parkingOptions: {}
    }
  },
  computed: {
  },
  mounted() {
    this.parkingOptions = buildChartOptions('pie', [
      { name: '远大中央公园1期', value: 125276 },
      { name: '远大中央公园1332', value: 22957 }
    ])
  },
  methods: {
    getParkingRevenue() {

    },
    completeCallback(status) {
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
  .stat-panels {
    justify-content: space-between;
    display: flex;
  }
</style>
